<template>
  <div class="legal-card">
    <div class="card-header" v-on:click="toggleExpand()">
      <div class="card-title">{{ name }}</div>
      <img :src="require('@/assets/icons/arrow-left.svg')" class="arrow" :class="{ expanded: expanded }">
    </div>
    <div v-if="expanded">
      <div v-for="legal in legals" :key="legal.index">
        <div class="card-header selection-title"
             v-on:click="legal.expanded = !legal.expanded"
             v-bind:class="{ 'selection-title-open': legal.expanded }">
          <div class="right">
            <div class="index">{{ legal.index }}</div>
            <div class="subject-header">{{ legal.name }}</div>
          </div>
          <div class="left">
            <img v-if="legal.expanded" :src="require('@/assets/icons/remove.svg')">
            <img v-else :src="require('@/assets/icons/add.svg')">
          </div>
        </div>
        <div v-if="legal.expanded" class="texty" v-html="legal.innerHTML"/>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Segment from '../../Segment';

export default {
  name: 'LegalCard',
  props: [
    'name',
    'legalsData',
  ],
  data() {
    return {
      legals: _.map(this.legalsData, (legal, index) => _.assign({ expanded: false, index: index > 9 ? `${index}` : `0${index}` }, legal)),
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        Segment.trackUserInteraction('TermsAndConditionsNavigation');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .legal-card {
    @include card;
    margin: 0 0 17px;

    .card-header {
      display: flex;
      justify-content: space-between;
      background-color: $riseup_white;
      border-bottom: solid 1px $riseup_gray_0;

      .card-title {
        @include card-title;
        margin: 17px 30px 20px 0;
      }
      .arrow {
        margin: 11px 19px 11px 15px;
        &.expanded {
          transform: rotate(-90deg);
        }
      }
    }
    .selection-title {
      color: $riseup_blue;
      font-size: 22px;
      padding: 17px 30px 17px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: right;
      cursor: pointer;
      transition: box-shadow 1s;
      &.selection-title-open {
        margin: 0 0 4px;
        border-radius: 2px;
        box-shadow: 0 3px 4px 0 $riseup_gray_1;
      }

      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 5px;

        .index {
          font-size: 14px;
          margin-bottom: 3px;
        }
        .subject-header {
          font-family: SimplerProBold;
          line-height: 22px;
        }
      }
    }

    .texty {
      text-align: right;
      padding: 13px;
      font-size: 14px;
      font-family: SimplerPro;
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      line-height: 1.3em;
      /deep/ .bold {
        font-weight: bold;
      }
      /deep/ h2 {
        font-size: 14px;
        font-weight: bold;
      }
      /deep/ .underline {
        text-decoration: underline;
      }
      /deep/ .notice {
        color: red;
      }
      /deep/ ul {
        padding: 0 13px 0 0;
        >> li {
          margin: 1em 0;
        }
      }
    }
  }

</style>
